export default __webpack_public_path__ + "static/media/sketch.b13fd32a.webp";